import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import { Navigate, useLocation } from "react-router-dom";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp } from "react-icons/fa6";
import SEO from "../../components/seo/Seo";
import { useEffect } from "react";
import { loadGoogleAnalytics } from "../../utils/loadAnalytics";
import useSeo from "../../hooks/useSeo";

const UserLayout = (props) => {
  const MessageButton = () => {
    const openMessageModal = () => {
      const phoneNumber = "919393991563";
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank");
    };

    return (
      <button
        className="fixed right-4 bottom-4 p-2 bg-[#f5e7e7] rounded-full shadow-lg hover:bg-[#f8bdbd] hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu"
        onClick={openMessageModal}
      >
        <FaWhatsapp size={32} color="#10b416" />
      </button>
    );
  };
const location = useLocation();
  const { seo, loading } = useSeo();

  useEffect(() => {
    if (!loading && seo?.googleAnalyticsId) {
      loadGoogleAnalytics(seo.googleAnalyticsId);
    }
  }, [loading, seo]);

  const isAdminRoute =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/products") ||
    location.pathname.startsWith("/industries") ||
    location.pathname.startsWith("/services");


  return (
    <React.Fragment>
       {!isAdminRoute && seo && <SEO seo={seo} />}
      <UserNavbar />
      {props.children}
      <UserFooter />

      {/* <MessageButton /> */}
    </React.Fragment>
  );
};

export default UserLayout;
